import React, {useCallback, useState} from "react";
import styles from "./PayCard.module.scss";
import {Autocomplete} from "../../ui-components";
import {CashIcon, LoaderIcon, SaveIcon} from "../../assets";
import {getCustomerSentrySingleRequests, getSentryRequestsList, updatePaymentInfoRequests} from "../requests/er-thunk";
import {useAppDispatch} from "../../core/hooks";
import {Spinner} from "../../shared";

const PayCard = ({request, isEditable=true}) => {
  const [paymentMethod, setPaymentMethod] = useState<string>(request?.payment?.type)
  const [loader, setLoader] = useState<boolean>(false)

  const dispatch = useAppDispatch()
  const handleSubmit = useCallback(() => {
    setLoader(true)
    dispatch(updatePaymentInfoRequests({
      uuid: request?.uuid,
      data: {
        payment_uuid: request?.payment.uuid,
        type: paymentMethod
      }
    })).then(res => {
      // @ts-ignore
      if(res) {
        dispatch(getSentryRequestsList(request?.uuid))
        // dispatch(getCustomerSentrySingleRequests(request?.uuid))

        setTimeout(() => {
          setLoader(false);
          // setAcceptSuccess(true);
        }, 1000); // Delay of 100ms
        // setAcceptSuccess(true)
      }
    })
  }, [dispatch, paymentMethod, request?.payment.uuid, request?.uuid])
  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        <CashIcon/>
        <div className={styles.title} >Способ оплаты</div>
      </div>
      <div className={styles.headWrapper} >
        {isEditable && (
          loader ? (
            <Spinner/>
          ) : (
            <SaveIcon style={{ cursor: "pointer" }} onClick={handleSubmit} />
          )
        )}
      </div>
    </div>
    <div className={styles.body} >
        <Autocomplete className={styles.select}
                      value={paymentMethod}
                      disabled={!isEditable}
                      options={[
                        { type: "Банковская Карта", key: 2 },
                        { type: "Наличные", key: 1 },
                        { type: "Перевод", key: 3 },
                      ]}
                      onChange={(data) => setPaymentMethod(data.key)}
                      optionLabel={'type'}
                      optionValue={'key'}
                      label="Способ оплаты"/>

      </div>
  </div>
}

export default PayCard
